var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlobTopRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 273,
    viewBox: "0 0 270 273",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.4095 213.395C35.1213 182.851 -2.68208 153.782 1.17277 112.307C5.43944 66.401 39.8541 26.6412 82.4192 8.86711C122.797 -7.9937 170.035 1.74418 205.822 26.8506C235.947 47.9859 236.823 88.1244 246.141 123.729C256.17 162.051 282.521 202.811 260.501 235.779C237.539 270.159 188.991 275.432 147.931 270.768C112.318 266.723 87.7505 239.677 63.4095 213.395Z",
    fill: "#FFFAD1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlobTopRight);
export default __webpack_public_path__ + "static/media/blob-top-right.a42530987b80a12bf1a3c7a2c2dbb867.svg";
export { ForwardRef as ReactComponent };